export default __webpack_public_path__ + "81609be878086201656f9be8e0a13b16.svg";